<template>
  <div
    class="submit-button"
    :class="{
      focused,
      rtl: dir === 'rtl',
      'new-header': newHeader,
      'submit-button-active': submitButtonActive
    }"
    tabindex="-1"
    @click="$emit('submit-search')"
  >
    <span>{{ translations.search }}</span>

    <NsSearchbarTooltip
      :message="translations.searchButtonTooltip"
      :disabled="!showTooltip"
      @close="$emit('disable-search-tooltip')"
    />
  </div>
</template>

<script>
import { DirUtil } from "@nuskin/ns-util";
import NsSearchbarTooltip from "./NsSearchbarTooltip.vue";

export default {
  name: "NsSearchbarButton",
  components: { NsSearchbarTooltip },
  props: {
    translations: {
      type: Object,
      default: function() {
        return {};
      }
    },
    focused: Boolean,
    newHeader: Boolean,
    showTooltip: Boolean,
    submitButtonActive: Boolean
  },
  computed: {
    dir() {
      return DirUtil.getDir();
    }
  }
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/global.mixins";
@use "~@nuskin/ns-core-styles/src/scss/colors";

.submit-button {
  position: relative;
  display: none;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 7px 17px;
  border: var(--global-border);
  border-radius: 0 5px 5px 0;
  border-left: none;
  color: var(--color-interactive-8);
  background-color: white;
  font-size: 13px;
  font-weight: var(--font-weight-semibold);
  letter-spacing: 0.8px;
  line-height: 16px;
  text-transform: uppercase;
  transition: var(--global-transition);
  outline: none;
  cursor: pointer;

  &.new-header {
    flex-shrink: 0;
    padding: 2px 10px;
    border: 1px solid rgb(236, 237, 237);
    border-radius: 0 3px 3px 0;
    border-left: none;
    min-width: 98px;

    &.rtl {
      border-left: 1px solid rgb(236, 237, 237);
    }
  }

  &.focused {
    border: var(--global-border-active);
    border-left: none;
  }

  &.focused,
  &:hover {
    color: var(--color-interactive-7);
  }

  &.submit-button-active {
    border: var(--global-border-active);
    border-left: none;
    color: white;
    background-color: var(--color-interactive-7);
  }

  &.rtl {
    border-radius: 5px 0 0 5px;
    border-left: var(--global-border);
    border-right: none;

    &.focused {
      border-left: var(--global-border-active);
      border-right: none;
    }
  }

  span {
    white-space: nowrap;
  }
}

@media (min-width: 1024px) {
  .submit-button {
    display: flex;
  }
}
</style>
